import { PaymentStatus } from "../../../cbi-generator/generated/dto/PaymentStatus";

export type PaymentStatusChip = { label: string; color: string };

const staffChips: Record<PaymentStatus, PaymentStatusChip> = {
  [PaymentStatus.PENDING]: { label: "Pending", color: "warning" },
  [PaymentStatus.CAPTURABLE]: { label: "Authorized", color: "info" },
  [PaymentStatus.SUCCESSFUL]: { label: "Successful", color: "success" },
  [PaymentStatus.FAILED]: { label: "Failed", color: "error" },
  [PaymentStatus.CANCELLED]: { label: "Cancelled", color: "grey" },
  [PaymentStatus.DISPUTED]: { label: "Disputed", color: "error" },
  [PaymentStatus.REFUNDED]: { label: "Refunded", color: "secondary" },
  [PaymentStatus.PARTIALLY_REFUNDED]: {
    label: "Partially refunded",
    color: "secondary",
  },
};

/** Staff see every payment status as a colored chip. */
export function staffPaymentStatusChip(
  status: PaymentStatus | null | undefined,
): PaymentStatusChip | null {
  return status
    ? (staffChips[status] ?? { label: status, color: "grey" })
    : null;
}

/**
 * Members only see payments that went through: an authorization (CAPTURABLE) reads the same as a
 * successful payment, and only disputes and refunds get a chip.
 */
export function memberPaymentVisible(status: PaymentStatus | null | undefined) {
  return (
    status != null &&
    ![
      PaymentStatus.PENDING,
      PaymentStatus.CANCELLED,
      PaymentStatus.FAILED,
    ].includes(status)
  );
}

export function memberPaymentStatusChip(
  status: PaymentStatus | null | undefined,
): PaymentStatusChip | null {
  return status &&
    [
      PaymentStatus.DISPUTED,
      PaymentStatus.REFUNDED,
      PaymentStatus.PARTIALLY_REFUNDED,
    ].includes(status)
    ? staffChips[status]
    : null;
}
